import { MUTE, UNMUTE, SHOW, HIDE } from 'aria-viewer/guide/avatarActions'
import { Map } from 'immutable'

const INITIAL_STATE = Map({
    isAvatarMuted: true,
    isAvatarShown: true,
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MUTE:
            return state.setIn(['isAvatarMuted'], true)
        case UNMUTE:
            return state.setIn(['isAvatarMuted'], false)
        case SHOW:
            return state.setIn(['isAvatarShown'], true)
        case HIDE:
            return state.setIn(['isAvatarShown'], false)
        default:
            return state
    }
}
